import { Checkbox, FormControlLabel } from '@mui/material';
import { useCallback, useMemo } from 'react';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { useAccessManagement } from 'components/ProfileSelectionCard/hooks';

import { BoxItemAll } from './styles';
import type { PartnerCompaniesSelectionAllProps } from './types';

export function PartnerCompaniesSelectionAll({
  profileId,
  hasContracts,
}: Readonly<PartnerCompaniesSelectionAllProps>) {
  const {
    selectedAllProfileId,
    setSelectedAllProfileId,
    currentUserId,
    selectedPartnerCompanies,
  } = useAccessManagement();

  const isEdit = Boolean(currentUserId);

  const isSelected = selectedAllProfileId === profileId;

  const isDisabled =
    (Boolean(selectedAllProfileId) && profileId !== selectedAllProfileId) ||
    !hasContracts;

  const handleCheckBoxChangeCallback = useCallback(() => {
    setSelectedAllProfileId(isSelected ? undefined : profileId);
  }, [profileId, isSelected]);

  const stateColorMemo = useMemo(() => {
    if (isSelected) return NEW_COLORS.SECONDARY[50];
    if (isDisabled) return NEW_COLORS.GRAYSCALE[100];
    return NEW_COLORS.BASE.WHITE;
  }, [isSelected, isDisabled]);

  const checkBoxLabel = useMemo(() => {
    if (isEdit || selectedPartnerCompanies.length > 0) {
      return 'Selecionar todos disponíveis';
    }
    return 'Selecionar todos';
  }, [isEdit, selectedPartnerCompanies.length]);

  return (
    <BoxItemAll
      stateColor={stateColorMemo}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <FormControlLabel
        control={
          <Checkbox
            disabled={isDisabled}
            checked={isSelected}
            onChange={handleCheckBoxChangeCallback}
          />
        }
        label={checkBoxLabel}
      />
    </BoxItemAll>
  );
}
